import { createSlice } from "@reduxjs/toolkit";

import {
  editEtfStrategyCases,
  setCollapseFilterReducer,
  setSelectedPortfolioReducer,
  setSelectedFilterReducer,
  addSelectedAssetsReducer,
  removeSelectedAssetsReducer,
  setSelectedAssetsReducer,
  updateSelectedAssetsReducer,
  resetEtfToDefaultReducer,
  setIsUnsavedReducer,
  setShowBacktestTabReducer,
  setDisabledSaveReducer,
} from "./reducer";

export const initialState = {
  isFilterVisible: true,
  errorMessage: "",
  isSaving: false,
  isUnsaved: false,
  showBacktestTab: false,
  selectedPortfolio: {
    allocations: {},
    name: "",
    frequency: 30,
    period: "days",
  },
  selectedFilter: {},
  selectedAssets: [],
  disabledSave: false,
};

export const etfBuilderSlice = createSlice({
  name: "etfBuilder",
  initialState,
  reducers: {
    setCollapseFilter: setCollapseFilterReducer,
    setSelectedPortfolio: setSelectedPortfolioReducer,
    setSelectedFilter: setSelectedFilterReducer,
    setSelectedAssets: setSelectedAssetsReducer,
    addSelectedAssets: addSelectedAssetsReducer,
    removeSelectedAssets: removeSelectedAssetsReducer,
    updateSelectedAssets: updateSelectedAssetsReducer,
    resetEtfToDefault: resetEtfToDefaultReducer,
    setIsUnsaved: setIsUnsavedReducer,
    setShowBacktestTab: setShowBacktestTabReducer,
    setDisabledSave: setDisabledSaveReducer,
  },
  extraReducers: (builder) => {
    editEtfStrategyCases(builder);
  },
});

export const {
  setCollapseFilter,
  setSelectedFilter,
  setSelectedPortfolio,
  addSelectedAssets,
  setSelectedAssets,
  removeSelectedAssets,
  updateSelectedAssets,
  resetEtfToDefault,
  setIsUnsaved,
  setShowBacktestTab,
  setDisabledSave,
} = etfBuilderSlice.actions;

export default etfBuilderSlice.reducer;
